import { stegaClean } from '@/lib/utils/stega';
import { ICONS, type IconName } from './UiIcon.constants';
import type { UiIconProps } from './UiIcon.types';

export function UiIcon({ name, size = 24, ...props }: UiIconProps) {
    // `name` may be a Sanity-stored value; strip stega so the key lookup works in draft mode too.
    const Icon = ICONS[stegaClean(name) as IconName];
    if (!Icon) return null;

    return <Icon width={size} height={size} {...props} />;
}
